.ao{max-width:100%;}